export default __webpack_public_path__ + "static/media/135.83378ed2.png";